export const textAnimation = {
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
  initial: {
    opacity: 0,
  },
  opacityIn: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.6,
      duration: 1,
      ease: 'easeOut',
    },
  },
  opacityOut: {
    opacity: 0,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeIn',
    },
  },
}
